/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewUiWorkflowStepFunctionPublishedEventOnSuccess } from '../models/new-ui-workflow-step-function-published-event-on-success';
import { UiWorkflowStepFunctionPublishedEventOnSuccess } from '../models/ui-workflow-step-function-published-event-on-success';
import { UiWorkflowStepFunctionPublishedEventOnSuccessPartial } from '../models/ui-workflow-step-function-published-event-on-success-partial';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class UiWorkflowStepFunctionPublishedEventOnSuccessControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation uiWorkflowStepFunctionPublishedEventOnSuccessControllerCount
   */
  static readonly UiWorkflowStepFunctionPublishedEventOnSuccessControllerCountPath = '/ui-workflow-step-function-published-event-on-successes/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, UiWorkflowStepFunctionPublishedEventOnSuccessControllerService.UiWorkflowStepFunctionPublishedEventOnSuccessControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation uiWorkflowStepFunctionPublishedEventOnSuccessControllerFindById
   */
  static readonly UiWorkflowStepFunctionPublishedEventOnSuccessControllerFindByIdPath = '/ui-workflow-step-function-published-event-on-successes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<UiWorkflowStepFunctionPublishedEventOnSuccess>> {

    const rb = new RequestBuilder(this.rootUrl, UiWorkflowStepFunctionPublishedEventOnSuccessControllerService.UiWorkflowStepFunctionPublishedEventOnSuccessControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UiWorkflowStepFunctionPublishedEventOnSuccess>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<UiWorkflowStepFunctionPublishedEventOnSuccess> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<UiWorkflowStepFunctionPublishedEventOnSuccess>) => r.body as UiWorkflowStepFunctionPublishedEventOnSuccess)
    );
  }

  /**
   * Path part for operation uiWorkflowStepFunctionPublishedEventOnSuccessControllerDeleteById
   */
  static readonly UiWorkflowStepFunctionPublishedEventOnSuccessControllerDeleteByIdPath = '/ui-workflow-step-function-published-event-on-successes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, UiWorkflowStepFunctionPublishedEventOnSuccessControllerService.UiWorkflowStepFunctionPublishedEventOnSuccessControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation uiWorkflowStepFunctionPublishedEventOnSuccessControllerUpdateById
   */
  static readonly UiWorkflowStepFunctionPublishedEventOnSuccessControllerUpdateByIdPath = '/ui-workflow-step-function-published-event-on-successes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: UiWorkflowStepFunctionPublishedEventOnSuccessPartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, UiWorkflowStepFunctionPublishedEventOnSuccessControllerService.UiWorkflowStepFunctionPublishedEventOnSuccessControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: UiWorkflowStepFunctionPublishedEventOnSuccessPartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation uiWorkflowStepFunctionPublishedEventOnSuccessControllerFind
   */
  static readonly UiWorkflowStepFunctionPublishedEventOnSuccessControllerFindPath = '/ui-workflow-step-function-published-event-on-successes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<UiWorkflowStepFunctionPublishedEventOnSuccess>>> {

    const rb = new RequestBuilder(this.rootUrl, UiWorkflowStepFunctionPublishedEventOnSuccessControllerService.UiWorkflowStepFunctionPublishedEventOnSuccessControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<UiWorkflowStepFunctionPublishedEventOnSuccess>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<UiWorkflowStepFunctionPublishedEventOnSuccess>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<UiWorkflowStepFunctionPublishedEventOnSuccess>>) => r.body as Array<UiWorkflowStepFunctionPublishedEventOnSuccess>)
    );
  }

  /**
   * Path part for operation uiWorkflowStepFunctionPublishedEventOnSuccessControllerCreate
   */
  static readonly UiWorkflowStepFunctionPublishedEventOnSuccessControllerCreatePath = '/ui-workflow-step-function-published-event-on-successes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewUiWorkflowStepFunctionPublishedEventOnSuccess
  }): Observable<StrictHttpResponse<UiWorkflowStepFunctionPublishedEventOnSuccess>> {

    const rb = new RequestBuilder(this.rootUrl, UiWorkflowStepFunctionPublishedEventOnSuccessControllerService.UiWorkflowStepFunctionPublishedEventOnSuccessControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UiWorkflowStepFunctionPublishedEventOnSuccess>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewUiWorkflowStepFunctionPublishedEventOnSuccess
  }): Observable<UiWorkflowStepFunctionPublishedEventOnSuccess> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<UiWorkflowStepFunctionPublishedEventOnSuccess>) => r.body as UiWorkflowStepFunctionPublishedEventOnSuccess)
    );
  }

}
